import { ClientsPage } from '../features/clients'

export default function Clients() {
  return <ClientsPage />
}

export { default as ClientDetail } from '../features/clients/ClientDetailPage.jsx'
